import { PageTitle } from "@/components/shared/title/page-title";
import React from "react";
import { PartsProvider } from "../parts/context/PartsContext";
import { RootTypeProvider } from "../rootTypes/context/RootTypeContext";
import { ComponentTypes } from "./ComponentTypesPage";
import { ComponentTypeProvider } from "./context/ComponentTypeContext";

const ComponentTypePages = () => {
	return (
		<>
			<PageTitle title="Component Types Management" />
			<RootTypeProvider>
				<PartsProvider>
					<ComponentTypeProvider>
						<ComponentTypes />
					</ComponentTypeProvider>
				</PartsProvider>
			</RootTypeProvider>
		</>
	);
};

export default ComponentTypePages;
